"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCommentaryDeleteMessage = exports.isCommentarySetMessage = void 0;
const isCommentarySetMessage = (msg) => msg.messageType === 'commentary-set';
exports.isCommentarySetMessage = isCommentarySetMessage;
const isCommentaryDeleteMessage = (msg) => msg.messageType === 'commentary-delete';
exports.isCommentaryDeleteMessage = isCommentaryDeleteMessage;
